/** Press and news corpus — Home shows a curated subset (WD-04). */
export const newsItems = [
  {
    id: 'haslam-spotlight',
    proofId: 'F-HASLAM',
    title:
      'DataRook Featured in UT Haslam Spotlight: Connecting Data Science & Athletics',
    excerpt:
      "The University of Tennessee's Haslam College of Business spotlighted founder Gus Alvarez-Suchini and DataRook — how footyLab teaches data science through soccer, plus his journey through UT's entrepreneurship ecosystem. Includes a featured video.",
    link: 'https://haslam.utk.edu/news/gus-alvarez-suchini-connecting-data-science-and-athletics/',
    featured: true,
  },
  {
    id: 'boyd-venture',
    title: "DataRook Competes in UT's Boyd Venture Challenge",
    excerpt:
      "DataRook was selected to compete in the University of Tennessee's Boyd Venture Challenge, pitching for non-dilutive grant funding to expand its data-science-through-soccer programs.",
    link: 'https://www.teknovation.biz/anderson-center-celebrates-boyd-venture-challenge-winners-granting-50000-to-students-2026/',
  },
  {
    id: 'graves-2025',
    proofId: 'F-GRAVES',
    title: 'DataRook Wins 1st Place at Fall 2025 Graves Business Plan Competition',
    excerpt:
      "DataRook took home first place in the growth category at the University of Tennessee's Graves Business Plan Competition, earning $5,000 in startup funding. The competition recognized DataRook's innovative approach to combining professional soccer technology with data science education.",
    link: 'https://haslam.utk.edu/news/ut-student-entrepreneurs-win-thousands-in-funding-at-fall-2025-graves-business-plan-competition/',
  },
  {
    id: 'sec-pitch',
    proofId: 'F-SEC',
    title: 'DataRook Represents UT at 2025 SEC Student Pitch Competition',
    excerpt:
      'Founder Gus Alvarez-Suchini represented the University of Tennessee at the SEC Student Pitch Competition, pitching DataRook alongside student entrepreneurs from all 16 Southeastern Conference universities at Vanderbilt University.',
    link: 'https://haslam.utk.edu/news/ut-student-represents-vols-at-sec-student-pitch-competition/',
  },
  {
    id: '865-fest',
    title: 'DataRook Selected to Pitch at 865 Fest',
    excerpt:
      "DataRook's founder, Gustavo Alvarez-Suchini, was selected as one of four emerging entrepreneurs to pitch at 865 Fest, Knoxville's premier entrepreneurial event featuring visionary keynotes, pitch competitions, and thought-provoking panels.",
    link: 'https://www.teknovation.biz/six-start-ups-selected-to-pitch-at-the-865-fest-in-knoxville/',
  },
  {
    id: 'the-works',
    title: 'DataRook Completes THE WORKS Startup Accelerator',
    excerpt:
      'DataRook participated in THE WORKS 2025, an intensive eight-week startup accelerator hosted by the Knoxville Entrepreneur Center, focused on customer insights, industry connections, and investment readiness.',
    link: 'https://knoxec.com/theworks2025/',
  },
  {
    id: 'teknovation-profile',
    title: 'DataRook Emerges as Gateway to STEM Education Through Soccer',
    excerpt:
      "Teknovation.biz features DataRook's mission to bring high-impact STEM education to underserved communities through soccer. Learn about our founding story, recent growth, and vision for the future.",
    link: 'https://www.teknovation.biz/datarook/',
  },
  {
    id: 'big-idea',
    title: "DataRook Wins Crowd Favorite at 'What's The Big Idea?' Pitch Competition",
    excerpt:
      "We're excited to announce that our Founder, Gustavo Alvarez-Suchini, won the Crowd Favorite award at Knoxville Entrepreneur Center's annual pitch competition!",
    link: 'https://www.teknovation.biz/whats-the-big-idea-shines-a-light-on-six-promising-start-ups-in-the-knoxville-area/',
  },
  {
    id: 'grand-challenges',
    title: 'From Goals to Graphs: Presenting at UT Grand Challenges Summit',
    excerpt:
      "DataRook presented 'From Goals to Graphs: Bridging STEM Education Gaps with Soccer Analytics' at the University of Tennessee Grand Challenges Summit 2025.",
    link: 'https://grandchallenges.tennessee.edu/2025-summit/schedule/',
  },
  {
    id: 'etfs-donate',
    title: 'Summer Program Partnership with East Tennessee Freedom Schools',
    excerpt:
      'DataRook is partnering with East Tennessee Freedom Schools to bring footyLab to their summer program, empowering middle school students through soccer and data science.',
    link: 'https://secure.givelively.org/donate/east-tennessee-freedom-schools/freedom-schools-datarook-deliver-stem-with-soccer',
  },
  {
    id: 'utk-accolades',
    proofId: 'F-ACCOLADES',
    title: 'DataRook Featured in University of Tennessee News',
    excerpt:
      'Our innovative approach to STEM education through soccer analytics was recently highlighted in a University of Tennessee feature article.',
    link: 'https://accolades.utk.edu/2024/09/25/kickstarting-futures/',
  },
];

/** Curated Home press display: Haslam featured + Graves + UT Accolades. */
export const homeNewsIds = ['haslam-spotlight', 'graves-2025', 'utk-accolades'];

export const getNewsByIds = (ids) =>
  ids.map((id) => newsItems.find((item) => item.id === id)).filter(Boolean);
